import React from 'react';
import { postData } from '../../helper';
import { ErrorToastComponent as ErrorToast } from '../../components/Toasts';

class ForgotPasswordForm extends React.Component {
    constructor(props) {
        super();
        this.state = {
            email: '',
            err_message: null
        }
        this.submitHandler = this.submitHandler.bind(this);
    }

    componentDidMount() {

    }

    onChangeHandler = (e) => {
        try {
            this.setState({
                [e.target.name]:e.target.value,
                err_message: ''
            })
        } catch(err) {
            throw new Error(err.message);
        }
    }

    async submitHandler(e) {
        try {
            e.preventDefault();

            const self = this;
            if(self.state.email.length === 0) return; 

            await postData('/auth/forgot-password',{
                email_id: self.state.email
            });

            window.location.href='/confirm-otp?email_id=yes';
            return;

        } catch(err) {
            throw new Error(err.message);
        }
    }

    renderErrorToast = () => {
        try {
            if(!this.state.err_message) return '';
            return <ErrorToast message={this.state.err_message}/>
        } catch(err) {
            return err.message;
        }
    }

    render() {
        return (
            <>
                <form className="user">
                    <div className="form-group">
                        <input type="email" className="form-control form-control-user"
                            id="inputEmail" aria-describedby="emailHelp"
                            placeholder="Enter Email Address..." value={this.state.email_id} 
                            name='email' onChange={this.onChangeHandler}/>
                    </div>
                    {this.renderErrorToast()}
                    <button type="button" className="btn btn-primary btn-user btn-block" onClick={this.submitHandler}>
                        Send Verification OTP
                    </button>
                </form>
            </>
        );
    }

}

export default ForgotPasswordForm;